import {
  readDeploymentContext,
  UNRELEASED_SHA,
} from "@shared/deployment/context";

const TELEMETRY_ENVIRONMENT_ALIASES: Record<string, string> = {
  dev: "development",
  development: "development",
  local: "development",
  preview: "preview",
  stage: "staging",
  staging: "staging",
  prod: "production",
  production: "production",
};

function normalizeEnvironmentName(value: string | undefined) {
  if (!value) return undefined;

  const normalizedValue = value.trim().toLowerCase();
  return TELEMETRY_ENVIRONMENT_ALIASES[normalizedValue] ?? normalizedValue;
}

export function resolveTelemetryEnvironment() {
  return (
    normalizeEnvironmentName(process.env.NEXT_PUBLIC_ENVIRONMENT) ??
    readDeploymentContext(process.env).environment
  );
}

export function resolveTelemetryRelease() {
  const release = process.env.NEXT_PUBLIC_RELEASE_SHA;

  return release && release.length > 0 ? release : undefined;
}

export function isUnreleasedBuild() {
  const release = resolveTelemetryRelease();
  return (
    resolveTelemetryEnvironment() === "development" ||
    release === undefined ||
    release === UNRELEASED_SHA
  );
}
